export default __webpack_public_path__ + "static/ErajRatnayake-3db2a531f6b3ed7c9ab7807987378c53.jpg";